export function PrivacyPolicy() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <h1 className="text-4xl font-bold text-gray-900 mb-8">Política de Privacidad</h1>

      <div className="prose prose-lg">
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">1. Responsable del tratamiento</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Identidad: Transcaravan Galicia SL</li>
            <li>CIF: B32507808</li>
            <li>Dirección: Calle Costa Castrelos 2, portal 5, 4A, 36213 Vigo (Pontevedra)</li>
            <li>Correo electrónico: info@furgosrio.com</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">2. Finalidad del tratamiento</h2>
          <p>
            En Furgos Río tratamos la información que nos facilitan las personas interesadas con los siguientes fines:
          </p>
          <ul className="list-disc pl-6 mt-4 space-y-2">
            <li>Gestionar reservas y alquileres de nuestras furgonetas camper</li>
            <li>Responder a consultas y solicitudes de información</li>
            <li>Enviar comunicaciones comerciales sobre nuestros servicios (solo si el usuario lo ha autorizado expresamente)</li>
            <li>Cumplir con obligaciones legales y fiscales</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">3. Legitimación</h2>
          <p>
            La base legal para el tratamiento de sus datos es:
          </p>
          <ul className="list-disc pl-6 mt-4 space-y-2">
            <li>La ejecución de un contrato de alquiler</li>
            <li>El consentimiento del interesado para el envío de comunicaciones comerciales</li>
            <li>El cumplimiento de obligaciones legales aplicables</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">4. Conservación de datos</h2>
          <p>
            Los datos personales proporcionados se conservarán:
          </p>
          <ul className="list-disc pl-6 mt-4 space-y-2">
            <li>Durante la relación contractual</li>
            <li>Hasta que el interesado solicite su supresión</li>
            <li>Durante el tiempo necesario para cumplir con las obligaciones legales</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">5. Destinatarios</h2>
          <p>
            Los datos no se comunicarán a terceros salvo obligación legal o cuando sea necesario para la prestación del servicio (como compañías aseguradoras para la cobertura del seguro del vehículo).
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">6. Derechos</h2>
          <p>
            Cualquier persona tiene derecho a:
          </p>
          <ul className="list-disc pl-6 mt-4 space-y-2">
            <li>Obtener confirmación sobre si estamos tratando datos personales que les conciernan</li>
            <li>Acceder a sus datos personales</li>
            <li>Solicitar la rectificación de los datos inexactos</li>
            <li>Solicitar su supresión cuando los datos ya no sean necesarios</li>
            <li>Solicitar la limitación del tratamiento de sus datos</li>
            <li>Oponerse al tratamiento de sus datos</li>
            <li>Solicitar la portabilidad de los datos</li>
          </ul>
          <p className="mt-4">
            Los interesados podrán ejercer sus derechos enviando un correo electrónico a info@furgosrio.com, adjuntando copia de su DNI.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">7. Reclamaciones</h2>
          <p>
            Los interesados tienen derecho a presentar una reclamación ante la Agencia Española de Protección de Datos si consideran que el tratamiento de sus datos personales infringe la normativa de protección de datos.
          </p>
        </section>
      </div>
    </div>
  );
} 